<template>
  <div>
    <el-tabs v-model="activeName" tab-position="left" class="XJTab">
      <el-tab-pane v-for="(item, index) in XJList" :key="index" :label="item.name" :name="item.name">
        <el-row>
          <div class="contentTitle"
               style="color: #ee7a18; font-size: 36px; padding: 20px 100px">
            {{that.$root.language == 1?item.textName:item.textName_en}}
          </div>
          <div class="content" style="padding: 20px 100px">
            <div class="top" style="padding-bottom: 20px; font-size: 24px">
              {{that.$root.language == 1?'1、产品概述':'1. GENERAL DESCRIPTION'}}
            </div>
            <div v-show="item.description1" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description1:item.description1_en}}
            </div>
            <div v-show="item.description2" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description2:item.description2_en}}
            </div>
            <div v-show="item.description3" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description3:item.description3_en}}
            </div>
            <div v-show="item.description4" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description4:item.description4_en}}
            </div>
            <div v-show="item.description5" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description5:item.description5_en}}
            </div>
            <div v-show="item.description6" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description6:item.description6_en}}
            </div>
            <img v-if="that.$root.language == 1" v-show="item.img1" :src="item.img3"
                 style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img1" :src="item.img3_en"
                 style="width: 100%" />
            <div v-show="item.description7" class="description" style="padding: 10px 0;text-indent: 2em">
              {{that.$root.language == 1?item.description7:item.description7_en}}
            </div>
            <div class="center" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'2、产品指标':'2、PRODUCT INDEX'}}
            </div>
            <img v-if="that.$root.language == 1" v-show="item.img1" :src="item.img1"
                 style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img1" :src="item.img1_en"
                 style="width: 100%" />
            <div class="bottom" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'3、应用性能比较':'3、TECHNICAL DATA'}}
            </div>
            <div v-show="item.compare1" class="compare" style="padding: 10px 0;text-indent: 2em">{{that.$root.language == 1?item.compare1:item.compare1_en}}</div>
            <div v-show="item.compare2" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare2:item.compare2_en}}</div>
            <div v-show="item.compare3" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare3:item.compare3_en}}</div>
            <div v-show="item.compare4" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare4:item.compare4_en}}</div>
            <div v-show="item.compare5" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare5:item.compare5_en}}</div>
            <div v-show="item.compare6" class="compare" style="padding: 10px 0;text-indent: 4em">{{that.$root.language == 1?item.compare6:item.compare6_en}}</div>
            <img v-if="that.$root.language == 1" v-show="item.img2" :src="item.img2" style="width: 100%" />
            <img v-if="that.$root.language != 1" v-show="item.img2" :src="item.img2_en" style="width: 100%" />
            <div class="remark">
              <div v-show="item.remark1" class="remarkFir" style="padding: 10px 0"> {{that.$root.language == 1?item.remark1:item.remark1_en}}</div>
              <div v-show="item.remark2" class="remarkSec" style="padding: 10px 0">{{that.$root.language == 1?item.remark2:item.remark2_en}}</div>
              <div v-show="item.remark3" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark3:item.remark3_en}}</div>
              <div v-show="item.remark4" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark4:item.remark4_en}}</div>
              <div v-show="item.remark5" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark5:item.remark5_en}}</div>
              <div v-show="item.remark6" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark6:item.remark6_en}}</div>
              <div v-show="item.remark7" class="remarkThi" style="padding: 10px 0; text-indent: 2em">{{that.$root.language == 1?item.remark7:item.remark7_en}}</div>
            </div>
            <div class="fourth" style="padding: 20px 0; font-size: 24px">
              {{that.$root.language == 1?'4、产品供应':'4、PRODUCT SUPPLY'}}
            </div>
            <div v-show="item.pack1" style="padding: 10px 0">{{that.$root.language == 1?item.pack1:item.pack1_en}}</div>
            <div v-show="item.pack2" style="padding: 10px 0">{{that.$root.language == 1?item.pack2:item.pack2_en}}</div>
            <div v-show="item.pack3" style="padding: 10px 0">{{that.$root.language == 1?item.pack3:item.pack3_en}}</div>
            <div v-show="item.pack4" style="padding: 10px 0">{{that.$root.language == 1?item.pack4:item.pack4_en}}</div>
          </div>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
        that:this,
        activeName: 'AL275',
      XJList: [
        {
          name: "AL275",
          textName: '安仑AL275特种炭黑',
          textName_en: 'AL275 SPECIAL CARBON BLACK',
          description1: 'AL275是安仑化工推出的一款平均粒径约25nm的挤出管材专用炭黑（P型炭黑），主要用于聚\n' +
                        '乙烯混配料、市政输水和输送燃气用聚乙烯压力管道的生产。',
          description1_en: 'AL275 is a P-type carbon black launched by Anlun Chemical with an average primary particle size of \n' +
                          '25nm, which is mainly used in polyethylene compound then for pressure pipeline application.',
          compare1: '与聚乙烯管道行业常用的普通色素炭黑（RCF）相比，AL275具有以下优异性能：',
          compare1_en: 'Compared with regular colour furnace black (RCR) commonly used in pipeline industry, AL275 has the following application characteristics:',
          compare2: ' 小粒径具有更强的紫外吸收能力，有效地提高制品的耐候性；',
          compare2_en: ' Strong UV absorption by small particle size to provide good weather resistance for product;',
          compare3: ' 极低的杂质和良好的分散性，保证聚乙烯材料的物理性能；',
          compare3_en: ' High purity and dispersibility to guarantee physical properties of polyethylene compound;',
          compare4: ' 极低的灰分和硫含量，保证聚乙烯管道的输水卫生和燃气安全；',
          compare4_en: ' Low ash and sulfur content to ensure the sanitary performance of polyethylene pipeline;',
          compare5: ' 过滤性能优良，延长挤出机滤网寿命，提高生产效率。',
          compare5_en: ' Excellent filtration performance to prolong the life of filter screen then to improve productivity.',
          remark1: '',
          remark1_en: '',
          pack1: ' 形态：湿法造粒',
          pack1_en: 'Product Form: wet pelletization',
          pack2: '包装：20kg PE袋/纸袋；500kg FIBC; 1,000kg FIBC',
          pack2_en: 'Packaging: 20kg PE; 500kg FIBC; 1,000kg FIBC',
          pack3: ' 形态：粉体',
          pack3_en: 'Product Form: powder',
          pack4: ' 包装：10kg PE袋/纸袋',
          pack4_en: 'Packaging: 10kg PE/Paper bag',
          img1: require("../../assets/img/qita/AL275-1.png"),
          img1_en: require("../../assets/img/qita/AL275-1-EN.png"),
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
  width: 150px;
}
::v-deep .el-tabs__item.is-active {
  background-color: rgba($color: #000000, $alpha: 0.1);
}
::v-deep .el-tabs__nav{
  background-color: #ffffff !important;
  color: #000000 !important;
}
::v-deep .el-tabs__item.is-active {
  color: #ee7a18 !important;
}
::v-deep .el-tabs__item:hover {
    color: #ee7a18 !important;
    cursor: pointer !important;
}
::v-deep .el-tabs__item.is-left{
  text-align: center;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
}
//::v-deep [id^="tab-AL"]{
//  text-align: center;
//  height: 50px;
//  font-size: 16px;
//  line-height: 50px;
//}
</style>